import React from 'react';
import '../auth.css';
import Logo from './logo.js';
import ModalModal from './modal.js';
import { Grid, Segment } from 'semantic-ui-react';
import SliderShow from '../components/slidershow';



const Login =() =>{

return (
<div className="background_cover">
  <div className="container">
  <Logo></Logo>

  <Grid columns={2} divided className="card_login">
    <Grid.Row stretched>


      <Grid.Column className="grid_login">
        <Segment>
        <ModalModal text_img="SIGN IN"></ModalModal>
        </Segment>
      </Grid.Column>

      <Grid.Column className="grid_slider">
        <Segment>
        <div className="slider_auth">
        <SliderShow 
        src_image1={require('../pictures/slider1.png')} 
        src_image2={require('../pictures/slider2.png')}
        src_image3={require('../pictures/slider4.png')}
        src_image4={require('../pictures/slider33.png')}
        />
        </div>
        </Segment>
      </Grid.Column>

    </Grid.Row>
  </Grid>


  </div>
  </div>


);
};


export default Login;
